/* jshint ignore:start */
var slide_index = 0;

jQuery(document).ready(function($) {

	var body = $("body");

	$.fullBackground({
		speed: 350,
		height: 710	});

	var slides = $("#background_slider").children(".slide");

	$("#background_slider iframe").each(function() {
		var src = $(this).attr('src');
		if( src != "" ) {
	        var wmode = "wmode=transparent";
	        if(src.indexOf('?') != -1) {
	            var getQString = src.split('?');
	            var oldString = getQString[1];
	            var newString = getQString[0];
	            $(this).attr('src',newString+'?'+wmode+'&'+oldString);
	        }
	        else $(this).attr('src',src+'?'+wmode);
		}
    });

    $("#background_slider .slide_type_video").each(function() {
    	slide_index = $(this).attr("data-index");
    	var id;

    	if( $(this).find("div.youtube").length > 0 ) {

    		var ytcontainer = $(this).find("div.youtube");

	    	id = ytcontainer.attr("id");
	    	var code = ytcontainer.attr("data-video");
	    	var params = { allowScriptAccess: "always" };
			var atts = { id: id };
			swfobject.embedSWF("http://www.youtube.com/v/"+code+"?enablejsapi=1&playerapiid=ytplayer&version=3&controls=0",
								id, "100%", "100%", "8", null, null, params, atts);

			var index = id.replace("player", "");
			addPlayPauseEvent(index, id);

    	} else {

    		var vmcontainer = $(this).find("iframe.vimeo");
    		Froogaloop(vmcontainer.get(0)).addEvent('ready', function(player_id) {
    			froogaloop = Froogaloop(player_id);
    			var index = player_id.replace("player", "");
    			addPlayPauseEvent(index, player_id);
    		});

    	}

    	function addPlayPauseEvent(index, id) {
    		$(".playpause[data-index="+index+"]").click(function() {
    			playpauseVideo(id, $(this));
    			return false;
    		});
    	}

    	function playVideo(id, playPauseButton) {
    		$("#" + id).prev("img").stop().animate({opacity: 0}, 350);
    		playPauseButton.html(playPauseButton.attr("data-text-pause"));
    		videoStatus = "paused";

    		if( document.getElementById(id) && document.getElementById(id).playVideo ) {
    			document.getElementById(id).playVideo();
    		}
    		else if( Froogaloop(id) !== undefined ) {
    			Froogaloop(id).api("play");
    		}
    	}

    	function pauseVideo(id, playPauseButton) {
    		$("#" + id).prev("img").stop().animate({opacity: 1}, 350);
    		playPauseButton.html(playPauseButton.attr("data-text-play"));
    		videoStatus = "playing"

    		if( document.getElementById(id) && document.getElementById(id).playVideo ) {
    			document.getElementById(id).pauseVideo();
    		}
    		else if( Froogaloop(id) !== undefined ) {
    			Froogaloop(id).api("pause");
    		}
    	}

    	function playpauseVideo(id, playPauseButton) {
    		if( videoStatus == "playing" ) {
    			$("#background_slider").cycle('pause');
    			playVideo(id, playPauseButton);
    		} else {
    			pauseVideo(id, playPauseButton);
    		}
	    }

	    $(".bg-prev, .bg-next").click(function() {

	    	if( $(".active_slide").hasClass("slide_type_video") ) {
	    		var index = $(".active_slide").attr("data-index");
	    		pauseVideo("player" + index, $(".playpause[data-index="+index+"]"));
	    		$("#background_slider").cycle('resume');
	    	}

	    	return true;
		});
   	});

    // Vimeo
	if(slides.length == 1) {
		$(".slide-box-caption .slide-overlay").css({ opacity : 1});
	} else {
	    function onBefore(currSlideElement, nextSlideElement, opts) {
	    	var index = $(currSlideElement).index();
	    	var nextCaption = $(".slide-box-caption .slide-overlay-"+index);

	    	$(currSlideElement).removeClass("active_slide");
	    	$(nextSlideElement).addClass("active_slide");

	    	if( $("body").hasClass("transitions") ) {
	    		nextCaption.removeClass("slide-in");
	    		nextCaption.addClass("slide-out");
	    	} else {
	    		$(".slide-box-caption .slide-overlay").css({ opacity : 0});
	    		$('.slide-overlay').stop().animate({ opacity : 0}, 350);
	    	}
	    }

	    function onAfter(currSlideElement, nextSlideElement, opts) {
	    	var index = $(nextSlideElement).index();
	    	var nextCaption = $(".slide-box-caption .slide-overlay-"+index);

	    	if( $("body").hasClass("transitions") ) {
	    		nextCaption.addClass("slide-in");
	    		nextCaption.removeClass("slide-out");
	    	}
	    	else {
	    		$(".slide-box-caption .slide-overlay").css({ opacity : 0});
	    		nextCaption.stop().animate({ opacity : 1}, 350);
	        }
	    }

	    var videoStatus = "playing";

		$("#background_slider").cycle({
			fx: 'fade',
			cleartypeNoBg: true,
			fit: true,
		    timeout: 6000,
			speed: 500,
		    pause: 0,
		    prev: $(".bg-prev"),
		    next: $(".bg-next"),
		    startingSlide: 0,
		    after: onAfter,
		    before: onBefore
		});
	}
});
<!-- Localized -->
